import React from 'react';
import { FreightBucket } from '../../types/bidding';
import { formatCurrency } from '../../utils/bidCalculator';
import './BucketEditor.css';

interface FreightBucketEditorProps {
  bucket: FreightBucket;
  onUpdate: (bucket: FreightBucket) => void;
  readOnly?: boolean;
}

const FreightBucketEditor: React.FC<FreightBucketEditorProps> = ({
  bucket,
  onUpdate,
  readOnly = false,
}) => {
  const handleUpdateInbound = (value: number) => {
    const inbound = value || 0;
    const total = inbound + bucket.outbound;
    onUpdate({ ...bucket, inbound, total });
  };

  const handleUpdateOutbound = (value: number) => {
    const outbound = value || 0;
    const total = bucket.inbound + outbound;
    onUpdate({ ...bucket, outbound, total });
  };

  return (
    <div className="bucket-editor freight-bucket-editor">
      <div className="bucket-header">
        <h4>Freight</h4>
        <div className="bucket-total">{formatCurrency(bucket.total)}</div>
      </div>

      <div className="freight-inputs">
        <div className="freight-input-group">
          <label htmlFor="inbound">Inbound (to PA shop)</label>
          {readOnly ? (
            <div className="freight-value">{formatCurrency(bucket.inbound)}</div>
          ) : (
            <input
              id="inbound"
              type="number"
              value={bucket.inbound}
              onChange={(e) => handleUpdateInbound(parseFloat(e.target.value) || 0)}
              min="0"
              step="1"
              placeholder="$0.00"
            />
          )}
        </div>

        <div className="freight-input-group">
          <label htmlFor="outbound">Outbound (to site)</label>
          {readOnly ? (
            <div className="freight-value">{formatCurrency(bucket.outbound)}</div>
          ) : (
            <input
              id="outbound"
              type="number"
              value={bucket.outbound}
              onChange={(e) => handleUpdateOutbound(parseFloat(e.target.value) || 0)}
              min="0"
              step="1"
              placeholder="$0.00"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FreightBucketEditor;
